<template>
  <van-nav-bar :title="t('indiqueAmigos.title')" :border="false" class="custom-nav-bar">
    <template #left>
      <Button type="back" @click="onClickLeft" />
    </template>
  </van-nav-bar>
  <div class="invite-page" @scroll="handleScroll" ref="containerRef">
    <div class="gilse">
      <div class="share-link">
        <span class="color-[#4CAE83] text-[12px]">{{ t('indiqueAmigos.myLink') }}:{{ shareLink }}</span>
        <img :src="getAssetsFile('home/copy4.png')" alt="" class="w-[14px] h-[14px]" @click="copyLink">
      </div>
      <div class="bg-[#00A97E] h-[1px] ml-[14px] mt-[18px]"></div>
      <div class="color-[#FFFFFF] text-[12px]  mt-[10px] ml-[15px]  font-bold">{{ t('indiqueAmigos.quickShare') }}</div>
      <!-- 分享软件图标 -->
      <div class="share-icons">
        <div class="icon-list">
          <div id="my-inline-buttons" style="z-index:999; position: relative;"></div>
          <!-- <img v-for="icon in icons" :key="icon" :src="icon" class="icon-img" /> -->
        </div>
      </div>
      <div class="bg-[#00A97E] h-[1px] ml-[14px] "></div>
      <!-- 我的下级 -->
      <div class="subordinate-bar">
        <span class="left color-[#FFFFFF] text-[12px]">{{ t('indiqueAmigos.myDirectSubordinates') }}<br />
          <span class="sub-count">{{ tuiages?.promoterNum || 0 }}{{ t('indiqueAmigos.person') }} (<span
              class="color-[#fff]">{{ t('indiqueAmigos.valid') }}</span> {{ tuiages?.validPromoterNum || 0 }}{{
                t('indiqueAmigos.person') }})</span>
        </span>
        <span class="right" @click="goDetail">{{ t('indiqueAmigos.details') }}<van-icon name="arrow" /></span>
      </div>
    </div>
    <!-- 宝箱奖励 -->
    <div class="chest-rewards">
      <div class="chest-row" v-for="(row, rowIndex) in chestRows" :key="rowIndex">
        <template v-for="(chest, index) in row" :key="chest.promotion">
          <div class="chest-item">
            <div class="chest-img-wrap">
              <img v-if="chest.status == 0" :src="getAssetsFile('home/weibao.png')" class="chest-img" />
              <img v-if="chest.status == 1" :src="getAssetsFile('home/kaibao.png')" class="chest-img"
                @click="goDrawBoxReward(chest.id)" />
              <img v-if="chest.status == 2" :src="getAssetsFile('home/yiabao.png')" class="chest-img" />
              <span class="chest-amount">{{ chest.reward }}</span>
            </div>
            <div class="chest-label">{{ t('indiqueAmigos.promotion') }} <span class="color-[#EBE33C]">{{ chest.num
            }}</span><br />{{ t('indiqueAmigos.person') }}</div>
          </div>
          <!-- 不是行内最后一个宝箱时显示箭头 -->
          <span v-if="index !== row.length - 1" class="chest-arrow">&gt;</span>
        </template>
      </div>
    </div>

    <!-- 流程图条件 -->
    <div class="condition-box">
      <div class="condition-title">
        {{ t('indiqueAmigos.effectivePromotionNumber') }}
      </div>
      <div class="bg-[#00A97E] h-[1px] mt-[4px]"></div>
      <div class="condition-list">
        <div class="condition-item">
          <div>{{ t('indiqueAmigos.subordinateRecharge') }}</div>
          <div class="color-[#EBE33C] text-[13px]">≥{{ tuiages?.recharge }}</div>
        </div>
        <div class="condition-item">
          <div>{{ t('indiqueAmigos.subordinateCumulativeBets') }}</div>
          <div class="color-[#EBE33C] text-[13px]">≥{{ tuiages?.bet }}</div>
        </div>
      </div>
    </div>

    <!-- 详细说明 -->
    <div class="detail-box">
      <div class="detail-title">{{ t('indiqueAmigos.eventDetails') }}:</div>
      <div class="detail-text" v-for="(text, idx) in details" :key="idx">{{ idx + 1 }}、{{ text }}</div>
    </div>
  </div>
  <!-- 在模板最后添加 RewardDialog 组件 -->
  <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { showToast } from 'vant'
import { useRouter } from 'vue-router'
import { computed, ref, onMounted, onUnmounted, reactive } from 'vue'
import { useClipboard } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import * as GameApi from '@/api/game';
import RewardDialog from '@/components/RewardDialog.vue'
import { useUserStore } from '@/stores/modules/user'
import { isLogin } from '@/utils/auth'
import { numberFormat } from '@/utils/formatter'
import { getAssetsFile } from '@/utils/pub-use'

const { t } = useI18n()
const router = useRouter()
const containerRef = ref(null)
const userStore = useUserStore()

// 分页参数
const page = ref(1)
const pageSize = ref(100)
const loading = ref(false)
const hasMore = ref(true)

// 从 userStore 获取用户信息，和 InviteLink 一样
const userInfo = computed(() => userStore.userInfo)

// 动态生成分享链接，修改逻辑
const shareLink = computed(() => {
  if (userInfo.value?.activeCode) {
    return `${window.location.origin}?pid=${userInfo.value.activeCode}`
  }
  // 未登录时显示默认链接
  return 'https://www.happybluewhale.com'
})

// 获取用户信息
// const fetchUserInfo = async () => {
//   try {
//     const res = await GameApi.userpromoterInfo()
//     if (res && res.data) {
//       userInfo.value = res.data
//     }
//   } catch (error) {
//     console.error('获取用户信息失败:', error)
//   }
// }

const facebook = getAssetsFile('home/facebook.png')
const watcapp = getAssetsFile('home/watcapp (1).png')
const tele = getAssetsFile('home/tele.png')
const instagram = getAssetsFile('SVG/instagram.svg')
const twitter = getAssetsFile('SVG/twitter.svg')
const tiktok = getAssetsFile('SVG/tiktok.svg')
const youtube = getAssetsFile('SVG/youtube.svg')

// 宝箱数据数组
const chestData = ref([])

// 将宝箱数据按每行4个分组
const chestRows = computed(() => {
  const rows = []
  for (let i = 0; i < chestData.value.length; i += 4) {
    rows.push(chestData.value.slice(i, i + 4))
  }
  return rows
})

const icons = [
  facebook,
  watcapp,
  tele,
  instagram,
  twitter,
  tiktok,
  youtube,
  facebook,
  watcapp,
  tele,
  instagram,
  twitter,
  tiktok,
  youtube,
]

// 动态生成条件数组，使用接口数据
const conditions = computed(() => [
  {
    text: 'The recharge of subordinates ',
    money: `≥${tuiages.value?.recharge || '0,00'}`
  },
  {
    text: 'The cumulative bets of subordinates ',
    money: `≥${tuiages.value?.bet || '10,00'}`
  },
])

const details = [
  t('indiqueAmigos.detail1'),
  t('indiqueAmigos.detail2'),
  t('indiqueAmigos.detail3'),
  t('indiqueAmigos.detail4'),
  t('indiqueAmigos.detail5'),
]
const shareContent = reactive({
  url: computed(() => shareLink.value), // 使用 computed 包装
  title: t('indiqueAmigos.shareTitle'),
  description: t('indiqueAmigos.shareDescription')
})
const { copy: copyToClipboard } = useClipboard()

// 复制链接
const copyLink = async () => {
  try {
    await copyToClipboard(shareLink.value)
    window.$toast(t('indiqueAmigos.copySuccess'))
  } catch (error) {
    window.$toast(t('indiqueAmigos.copyFailed'))
  }
}

const goDetail = () => {
  router.push('/activity/components/activityIndex/Detalhes')
}

const onClickLeft = () => {
  router.back()
}

// 滚动处理函数
function handleScroll(event: Event) {
  const target = event.target as HTMLElement
  const scrollTop = target.scrollTop
  const scrollHeight = target.scrollHeight
  const clientHeight = target.clientHeight

  // 当滚动到距离底部100px时触发加载
  if (scrollHeight - scrollTop - clientHeight < 100 && !loading.value && hasMore.value) {
    loadMore()
  }
}

// 加载更多数据
async function loadMore() {
  if (loading.value || !hasMore.value) return

  page.value++
  await fetchChestData(true) // true表示追加数据
}

// 重置分页
function resetPagination() {
  page.value = 1
  hasMore.value = true
  chestData.value = []
}

// 获取宝箱数据
async function fetchChestData(isAppend = false) {
  // 如果未登录，不执行API调用
  if (!isLogin()) {
    chestData.value = []
    return
  }

  if (loading.value) return

  loading.value = true
  try {
    const params = {
      page: page.value,
      pageSize: pageSize.value
    }

    const res = await GameApi.getPromoterBox(params)

    if (res && res.data && res.data.list) {
      const newData = res.data.list

      if (isAppend) {
        // 追加数据
        chestData.value = [...chestData.value, ...newData]
      } else {
        // 替换数据
        chestData.value = newData
      }

      // 判断是否还有更多数据
      hasMore.value = newData.length === pageSize.value
    }
  } catch (error) {
    console.error('获取宝箱数据失败:', error)
    if (!isAppend) {
      chestData.value = []
    }
  } finally {
    loading.value = false
  }
}

// 添加推广信息状态
const tuiages = ref<any>({
  commissionInfo: [],
  commission: 0,
  profit: 0,
  promoterNum: 0,
  recharge: '0,00', // 添加默认值
  bert: '0,00'     // 添加默认值
})

// 初始化 ShareThis 的函数
const initShareThis = () => {
  if ((window as any).__sharethis__) {
    // 先清除可能存在的旧内容
    const container = document.getElementById('my-inline-buttons')
    if (container) {
      container.innerHTML = ''
    }

    (window as any).__sharethis__.load('inline-share-buttons', {
      alignment: 'justified',
      id: 'my-inline-buttons',
      enabled: true,
      font_size: 8,
      padding: 5,
      radius: 50,
      networks: ['facebook', 'twitter', 'whatsapp', 'telegram'],
      size: 40,
      show_mobile_buttons: true,
      spacing: 4,
      url: shareContent.url, // custom url
      title: shareContent.title,
      language: 'en',
      image: '', // useful for pinterest sharing buttons
      description: shareContent.description,
      username: '' // custom @username for twitter sharing
    })
  }
}

// 监听分享按钮是否消失的函数
const checkShareButtons = () => {
  const container = document.getElementById('my-inline-buttons')
  if (container && container.children.length === 0) {
    console.log('检测到分享按钮消失，重新初始化...')
    initShareThis()
  }
}

// 添加滚动监听器，在滚动时检查分享按钮
const handleScrollCheck = () => {
  checkShareButtons()
}

onMounted(async () => {
  // 延迟初始化 ShareThis，确保 DOM 完全加载
  setTimeout(() => {
    initShareThis()
  }, 500)

  // 添加滚动监听器
  window.addEventListener('scroll', handleScrollCheck, { passive: true })

  // 如果未登录，只初始化分享功能，不调用需要登录的API
  if (!isLogin()) {
    return
  }

  // 获取其他数据
  await fetchChestData()

  // 获取推广信息
  try {
    const promoterRes = await GameApi.userpromoterInfo()
    tuiages.value = promoterRes.data
    console.log(tuiages.value, '厚度我还')
  } catch (error) {
    console.error('获取推广信息失败:', error)
  }
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollCheck)
})

// 添加弹窗相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

const goDrawBoxReward = async (id: number) => {
  // 如果未登录，不执行
  if (!isLogin()) {
    return
  }

  try {
    const res = await GameApi.drawBoxReward(id)

    if (res && res.data) {
      // 显示奖励弹窗
      rewardAmount.value = res.data
      showRewardDialog.value = true
    } else {
      (window as any).$toast('error')
    }
  } catch (error: any) {
    (window as any).$toast('error')
  }
}

// 处理奖励确认
const handleRewardConfirm = async () => {
  console.log('奖励已确认')

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 刷新宝箱数据，这会更新宝箱状态
  try {
    resetPagination()
    await fetchChestData()
  } catch (error) {
    console.error('刷新宝箱数据失败:', error)
  }
}
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.gilse {
  background: #00563A;
  border-radius: 9px;
}

.invite-page {
  color: #4CAE83;
  font-size: 11px;
  padding: 10px;
  background: #004d37;
  min-height: 100vh;
  overflow-y: auto;
  height: 100vh;
}

.share-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 16px 0 16px;
}

.copy-icon {
  margin-left: auto;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.share-icons {
  overflow-x: auto;
  margin-left: 15px;
  margin-top: 12px;
  margin-bottom: 15px;
  margin-right: 15px;
  /* 隐藏滚动条 */
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

/* 隐藏 Webkit 浏览器的滚动条 */
.share-icons::-webkit-scrollbar {
  display: none;
}

.icon-list {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon-img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.subordinate-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  padding: 3px 12px;
}

.sub-count {
  color: #EBE33C;
}

.right {
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 10px;
  cursor: pointer;
}

.chest-rewards {
  background: #00563A;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;
  margin-top: 11px;
  display: flex;
  flex-wrap: wrap;
}

.chest-row {
  display: flex;
  margin-bottom: 8px;
  width: 100%;
}

.chest-item {
  text-align: center;
  width: calc(100% / 4 - 8px);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.chest-img-wrap {
  position: relative;
  display: inline-block;
  width: 100%;
}

.chest-img {
  width: 59px;
  height: 45px;
  max-width: 100%;
}

.chest-amount {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 1px;
  /* 关键：多重红色阴影，制造发光包裹感 */
  text-shadow:
    0 0 1px #ff0000,
    0 0 3px #ff0000,
    0 0 5px #ff0000,
    0 0 7px #ff0000,
    0 0 8px #ff0000;
  padding: 0 4px;
  border-radius: 0;
  background: none;
  border: none;
  line-height: 1;
}

.chest-label {
  margin-top: 2px;
  color: #4CAE83;
  margin-top: 20px;
  font-size: 10px;
  word-break: break-word;
}

.condition-box {
  background: #00563A;
  border-radius: 10px;
  margin-bottom: 10px;
}

.condition-title {
  font-weight: bold;
  color: #fff;
  padding: 8px 13px 0 13px;
  font-size: 12px;
}

.condition-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 24px 0 14px;
}

.condition-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  justify-content: space-between;
  border-bottom: 1px solid #00A97E;
  margin-bottom: 4px;
}

.arrow {
  margin: 0 4px;
  color: #ffd700;
}

.detail-box {
  background: #00563A;
  border-radius: 10px;
  padding: 16px 13px;
  color: #4CAE83;
  font-size: 11px;
}

.detail-title {
  margin-bottom: 12px;
}

.detail-text {
  margin-bottom: 4px;
}

.chest-arrow {
  display: inline-block;
  color: #fff;
  font-size: 12px;
  vertical-align: middle;
  margin: 20px 4px 0 4px;
  flex-shrink: 0;
}

/* 保护分享按钮容器的样式 */
#my-inline-buttons {
  position: relative !important;
  z-index: 999 !important;
  min-height: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 确保 ShareThis 按钮在移动端正常显示 */
#my-inline-buttons * {
  position: relative !important;
  z-index: 1000 !important;
}

/* 移动端特殊保护 */
@media (max-width: 768px) {
  #my-inline-buttons {
    z-index: 999 !important;
    position: relative !important;
    touch-action: manipulation;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

/* PC端优化 */
@media (min-width: 769px) {
  #my-inline-buttons {
    z-index: 999 !important;
    position: relative !important;
    min-height: 20px;
    padding: 4px 0;
  }

  /* PC端分享按钮样式优化 */
  #my-inline-buttons * {
    transition: all 0.2s ease;
  }

  #my-inline-buttons *:hover {
    transform: scale(1.05);
    opacity: 0.9;
  }
}
</style>
<route lang="json5">
{
  name: 'IndiqueAmigos',
  meta: {
    title: 'IndiqueAmigos',
    i18n: 'menus.IndiqueAmigos'
  },
}
</route>
